import { Directionality } from "@angular/cdk/bidi";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Optional, Output } from "@angular/core";
import { NzButtonGroupComponent } from "ng-zorro-antd/button";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { UiIsMenuInsideDropDownToken } from "@webapp/ui/menu/utils/menu.utils";
import { UiButtonSize, UiButtonSplitType } from "../../models/button.models";

@Component({
  selector: "ui-button-split",
  exportAs: "uiButtonSplit",
  templateUrl: "./button-split.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: "ant-btn-group btn-split",
    "[class.ant-btn-group-lg]": `nzSize === 'large'`,
    "[class.ant-btn-group-sm]": `nzSize === 'small'`,
    "[class.ant-btn-group-rtl]": `dir === 'rtl'`,
  },
  providers: [
    {
      provide: UiIsMenuInsideDropDownToken,
      useValue: true,
    },
  ],
})
export class UiButtonSplitComponent extends NzButtonGroupComponent {
  @Input("uiSize") public nzSize: UiButtonSize = "default";
  @Input() public uiType: UiButtonSplitType = "default";
  @Input() public uiButtonText: string;
  @Input() @InputBoolean() public uiDisabled: boolean;
  @Output() public readonly buttonClick = new EventEmitter<void>();

  constructor(@Optional() directionality?: Directionality) {
    super(directionality);
  }
}
